import React from 'react';
import UploadDocsSec from './UploadDocsSec';

function PageUploadPopup({ uploadCb, handleClose, parentId }) {
  return (
    <div className="modalBackground">
      <div
        className="center-popup"
        style={{
          backgroundColor: '#fff',
          position: 'absolute',
        }}
      >
        <div
          style={{
            display: 'flex',
            borderBottom: '1px solid rgb(204, 204, 204)',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '10px 10px 5px 0',
          }}
        >
          <div
            className="nsu-act-lbl"
            style={{
              fontSize: '14px',
              fontWeight: 'bold',
            }}
          >
            Upload page
          </div>
          <div
            className="width100 flex-sec red bold"
            style={{ flexDirection: 'row-reverse' }}
            onClick={handleClose}
          >
            X
          </div>
        </div>
        <UploadDocsSec
          uploadCb={uploadCb}
          parentId={parentId}
          closeUploadPagePopup={handleClose}
        />
        <div
          style={{
            textAlign: 'right',
            borderTop: '1px solid #ccc',
            padding: '5px',
          }}
        >
          <div
            style={{
              fontSize: '14px',
              fontWeight: 'bold',
              border: '1px solid #ccc',
              padding: '5px 10px',
              display: 'inline-block',
            }}
            onClick={handleClose}
          >
            Close
          </div>
        </div>
      </div>
    </div>
  );
}

export default PageUploadPopup;
